const DeezerIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 109 72"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
  >
    <path d="M108.3 0.699997H84.9V14.4H108.3V0.699997Z" />
    <path d="M108.3 19.7H84.9V33.4H108.3V19.7Z" />
    <path d="M108.3 38.7H84.9V52.4H108.3V38.7Z" />
    <path d="M23.4 57.7H0V71.4H23.4V57.7Z" />
    <path d="M51.7 57.7H28.3V71.4H51.7V57.7Z" />
    <path d="M80 57.7H56.6V71.4H80V57.7Z" />{" "}
    <path d="M108.3 57.7H84.9V71.4H108.3V57.7Z" />
    <path d="M80 38.7H56.6V52.4H80V38.7Z" />
    <path d="M51.7 38.7H28.3V52.4H51.7V38.7Z" />
    <path d="M51.7 19.7H28.3V33.4H51.7V19.7Z" />
  </svg>
);

export default DeezerIcon;
